<app-presentacion></app-presentacion>
<app-transmite-practica></app-transmite-practica>
<app-estas-listo></app-estas-listo>
<app-unete-comunidad></app-unete-comunidad>
